import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import * as XLSX from 'xlsx';

const IncentiveReport = () => {
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedDate, setSelectedDate] = useState("");
    const [getData, setGetData] = useState([]);
    // console.log("get data",getData)

    useEffect(() => {
        const fetchInvoiceData = async () => {
            try {
                const response = await axios.get('https://api.trucoo.in/invoice/invoice/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });
                if (response.data.status === 'success') {
                    setGetData(response.data.data || []);
                }
            } catch (error) {
                console.error("Error fetching invoice data:", error);
            }
        };

        fetchInvoiceData();
    }, []);
    
    const currentYear = new Date().getFullYear();
    const filteredData = getData.filter(order => {
        const orderDate = new Date(order.date);
        return (
            orderDate.getFullYear() === currentYear &&
            orderDate.getMonth() + 1 === selectedMonth &&
            (selectedDate === "" || orderDate.toLocaleDateString('en-CA') === selectedDate)
        );
    });

    const groupedByRoute = {};
    let grandTotal = {
        totalMilkQuantity: 0,
        totalCurdQuantity: 0,
        totalLiters: 0,
        totalAmountClaim: 0,
        commission: 0,
        netClaimedAmount: 0,
        leakageAdjustment: 0,
        totalClaim: 0
    };

    filteredData.forEach(order => {
        const dealer = order.dealerData?.dealer || "Unknown Dealer";
        const route = order.dealerData?.routes || "Unknown Route";
        const location = order.dealerData?.locations || "Unknown Location";
        const incentive = parseFloat(order.dealerData?.incentive || 0);
        const transPort = parseFloat(order.dealerData?.transPort || 0);
        const margin = parseFloat(order.dealerData?.margin || 0);
        const schemeValue = parseFloat(order.schemeValue || 0);
        // const schema = parseFloat(order.dealerData?.fraction || 0)/parseFloat(order.dealerData?.values || 0);
        const denominator = parseFloat(order.dealerData?.values || 0);
        const numerator = parseFloat(order.dealerData?.fraction || 0);
        const schema = denominator === 0 ? 0 : numerator / denominator;
        // console.log("fraction",order.dealerData?.fraction)
        // console.log("values",order.dealerData?.values)
        // console.log("schema",schema)

        if (!groupedByRoute[route]) {
            groupedByRoute[route] = {
                dealers: {},
                routeTotal: {
                    totalMilkQuantity: 0,
                    totalCurdQuantity: 0,
                    totalLiters: 0,
                    totalDiscount: 0,
                    totalAmountClaim: 0,
                    commission: 0,
                    netClaimedAmount: 0,
                    leakageAdjustment: 0,
                    totalClaim: 0
                }
            };
        }

        if (!groupedByRoute[route].dealers[dealer]) {
            groupedByRoute[route].dealers[dealer] = { 
                location, 
                totalMilkQuantity: 0, 
                totalCurdQuantity: 0, 
                totalLiters: 0, 
                totalDiscount: 0,
                incentive,
                transPort,
                margin,
                schema,
                schemeValue
            };
        }

        if (Array.isArray(order.orderData)) {
            order.orderData.forEach(item => {
                const quantity = parseFloat(item.qty) || 0;
                const itemWeight = parseFloat(item.itemWeight) || 0;
                const grade = parseFloat(item.itemGrade) || 1;
                const liters = (itemWeight * quantity * grade) / 1000;
                const discount = parseFloat(item.discountValue) || 0;

                if (item.itemUnit === "L") {
                    groupedByRoute[route].dealers[dealer].totalMilkQuantity += quantity;
                    groupedByRoute[route].routeTotal.totalMilkQuantity += quantity;
                } else if (item.itemUnit === "KG") {
                    groupedByRoute[route].dealers[dealer].totalCurdQuantity += quantity;
                    groupedByRoute[route].routeTotal.totalCurdQuantity += quantity;
                }

                groupedByRoute[route].dealers[dealer].totalLiters += liters;
                groupedByRoute[route].dealers[dealer].totalDiscount += discount;
                
                groupedByRoute[route].routeTotal.totalLiters += liters;
                groupedByRoute[route].routeTotal.totalDiscount += discount;
            });
        }
    });

    Object.keys(groupedByRoute).forEach(route => {
        const routeData = groupedByRoute[route];
        
        // dealer totals
        Object.keys(routeData.dealers).forEach(dealer => {
            const dealerData = routeData.dealers[dealer];
            const totalClaimPerLiter = dealerData.incentive + dealerData.schema + dealerData.totalDiscount + 
                                      dealerData.transPort + dealerData.margin;
            const totalAmountClaim = totalClaimPerLiter * dealerData.totalLiters;
            const commission = dealerData.totalLiters * 1.5;
            const netClaimedAmount = totalAmountClaim + commission;
            const leakageAdjustment = (parseFloat(dealerData.totalLiters) || 0) * 0.004 * 55;
            
            dealerData.totalClaimPerLiter = totalClaimPerLiter;
            dealerData.totalAmountClaim = totalAmountClaim;
            dealerData.commission = commission;
            dealerData.netClaimedAmount = netClaimedAmount;
            dealerData.leakageAdjustment = leakageAdjustment;
            dealerData.totalClaim = netClaimedAmount + leakageAdjustment;
            
            // route totals
            routeData.routeTotal.totalAmountClaim += totalAmountClaim;
            routeData.routeTotal.commission += commission;
            routeData.routeTotal.netClaimedAmount += netClaimedAmount;
            routeData.routeTotal.leakageAdjustment += leakageAdjustment;
            routeData.routeTotal.totalClaim += netClaimedAmount + leakageAdjustment;
        });

        // grand totals
        grandTotal.totalMilkQuantity += routeData.routeTotal.totalMilkQuantity;
        grandTotal.totalCurdQuantity += routeData.routeTotal.totalCurdQuantity;
        grandTotal.totalLiters += routeData.routeTotal.totalLiters;
        grandTotal.totalAmountClaim += routeData.routeTotal.totalAmountClaim;
        grandTotal.commission += routeData.routeTotal.commission;
        grandTotal.netClaimedAmount += routeData.routeTotal.netClaimedAmount;
        grandTotal.leakageAdjustment += routeData.routeTotal.leakageAdjustment;
        grandTotal.totalClaim += routeData.routeTotal.totalClaim;
    });
    

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, 'incentive_Report.xlsx');
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Invoice Reports</h4>
                                <p className="mb-0 box-subtitle">Dealers Invoice Report</p>
                            </div>
                            <div className="box-body">
                                <div className="col-lg-3 mb-4">
                                    <select 
                                        value={selectedMonth} 
                                        onChange={(e) => setSelectedMonth(Number(e.target.value))} 
                                        className="border p-2"
                                    >
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>{new Date(0, i).toLocaleString('en', { month: 'long' })}</option>
                                        ))}
                                    </select>
                                    <input 
                                        type="date" 
                                        value={selectedDate} 
                                        onChange={(e) => setSelectedDate(e.target.value)} 
                                        className="border p-2" 
                                    />
                                </div>
                                <div className="col-lg-12 mb-4" align="right">
                                    <button onClick={downloadExcel} className="btn btn-primary"> Download Excel </button>
                                </div>

                               <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr>
                                                <th>ROUTE</th>
                                                <th>DEALER NAME</th>
                                                <th>AREA</th>
                                                <th>MILK</th>
                                                <th>CURD</th>
                                                <th>TOTAL LITTER</th>
                                                <th>INC/LIT</th>
                                                <th>SEC/LIT</th>
                                                <th>TOTAL CLAIM / LIT</th>
                                                <th>TOTAL AMOUNT</th>
                                                <th>C/F COMMISSION</th>
                                                <th>NET CLAIM AMT</th>
                                                <th>Leakage Adjesment Amt</th>
                                                <th>TOTAL CLAIM</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(groupedByRoute).map((route, routeIndex) => {
                                                const routeData = groupedByRoute[route];
                                                const dealers = Object.keys(routeData.dealers);

                                                return [
                                                    // Dealer rows
                                                    ...dealers.map((dealer, dealerIndex) => {
                                                        const dealerData = routeData.dealers[dealer];
                                                        return (
                                                            <tr key={`${route}-${dealer}`}>
                                                                {dealerIndex === 0 ? (
                                                                    <td rowSpan={dealers.length + 1}>{route}</td>
                                                                ) : null}
                                                                <td>{dealer}</td>
                                                                <td>{dealerData.location}</td>
                                                                <td>{parseFloat(dealerData.totalMilkQuantity).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.totalCurdQuantity).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.totalLiters).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.incentive).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.schema).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.totalClaimPerLiter).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.totalAmountClaim).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.commission).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.netClaimedAmount).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.leakageAdjustment).toFixed(2)}</td>
                                                                <td>{parseFloat(dealerData.totalClaim).toFixed(2)}</td>
                                                            </tr>
                                                        );
                                                    }),
                                                    // Route total row
                                                    <tr key={`${route}-total`} style={{ fontWeight: 'bold' }}>
                                                        <td colSpan="2">Route Total</td>
                                                        <td>{parseFloat(routeData.routeTotal.totalMilkQuantity).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.totalCurdQuantity).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.totalLiters).toFixed(2)}</td>
                                                        <td colSpan="3"></td>
                                                        <td>{parseFloat(routeData.routeTotal.totalAmountClaim).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.commission).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.netClaimedAmount).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.leakageAdjustment).toFixed(2)}</td>
                                                        <td>{parseFloat(routeData.routeTotal.totalClaim).toFixed(2)}</td>
                                                    </tr>
                                                ];
                                            })}
                                            {/* Grand Total row */}
                                            <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                                <td colSpan="2">GRAND TOTAL</td>
                                                <td></td>
                                                <td>{parseFloat(grandTotal.totalMilkQuantity).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.totalCurdQuantity).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.totalLiters).toFixed(2)}</td>
                                                <td colSpan="3"></td>
                                                <td>{parseFloat(grandTotal.totalAmountClaim).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.commission).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.netClaimedAmount).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.leakageAdjustment).toFixed(2)}</td>
                                                <td>{parseFloat(grandTotal.totalClaim).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default IncentiveReport;